import { template } from "@ember/template-compiler";
import { service } from '@ember/service';
import Component from '@glimmer/component';
import SignInLinkTo from '../sign-in/link-to';
import t from 'ember-intl/helpers/t';
export default class RequestSignInTeaser extends Component {
    @service
    currentPractice;
    get boxClass() {
        return this.args.therapyfinderEmbed ? 'sign-in-box-therapyfinder-embed' : 'sign-in-box';
    }
    get visibilityBreakpoint() {
        return this.args.visibilityBreakpoint === 'md' ? 'md' : 'lg';
    }
    get rootClassNames() {
        return `d-${this.visibilityBreakpoint}-none ${this.boxClass}`;
    }
    get isWidgetCopy() {
        return this.args.copySet === 'widget';
    }
    get externalHref() {
        return `${this.currentPractice.get('practiceUrl') ?? ''}sign-in`;
    }
    get isExternalLink() {
        return this.args.linkVariant === 'external';
    }
    static{
        template(`
    <div class={{this.rootClassNames}} data-test-sign-in-box>
      <span>{{t
          (if this.isWidgetCopy "booking.widget.signIn.alreadyClient" "signIn.alreadyAClient")
        }}</span>
      <span>
        {{t
          (if this.isWidgetCopy "booking.widget.signIn.toRequest" "signIn.toRequestAnAppointment")
        }}
        {{#if this.isExternalLink}}
          <a href={{this.externalHref}} target="_blank" rel="noopener noreferrer">
            {{t (if this.isWidgetCopy "booking.widget.signIn.signIn" "signIn.signIn")}}
          </a>
        {{else}}
          <SignInLinkTo />
        {{/if}}
      </span>
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
